import { computed, defineComponent } from 'vue'
import { useSmartBack } from '@/composables/use-smart-back'
import { useSiteConfigStore } from '@/stores/site-config-store'
import { NavBar as VanNavBar, Icon as VanIcon } from 'vant'

function buildRuleText(name: string) {
  return `${name}用户规则

①:禁止发布包含任何网址，任何联系方式，二维码,网站名称！资料请先马赛克处理后在进行分享发布！如有违规将永久禁言！

②:用户昵称禁止使用敏感词汇以及国家领导人名字，用户头像禁止使用二维码，色情图片,国家领导人,如有发现永久禁言！

③:为不影响用户正常查看心水贴,禁止发表消极内容，重复，空贴，辱骂，跟六合无关，马后炮等多次不听劝阻者永久禁言！

④:禁止索要联系方式,网投网址,外网网址,微信群图片，其他平台名称,一经发现即刻禁言！

⑤:禁止对用户发表的心水贴冷嘲热讽,辱骂攻击，恶语中伤！违者禁言处理！

⑥:高手们研究发帖不易，请大家理性参考，心存感恩查阅资料且文明交流对错不怪！因为没人能保证谁的一定准。

⑦:禁止高手主动要求粉丝给自己打赏，发现当卖料处理。轻者删贴，重者封号！

⑧:发帖规则：每人每期只可以发布三个主题贴，达到上限后可以自行修改已发布的帖子，发帖账号必须是中文昵称三个以上汉字，不能带数字和字母，请联系在线客服修改昵称， 望大家悉知，禁止注册多账号发帖套利{每位用户仅限注册一个账号}六合论坛发帖内容禁止空降料，必须实战记录，附带网料图片的不能带有网址广告。

网络安全，从自身做起，勿轻信他人，别轻易去加广告狗子发的微信，QQ等任何联系方式。

遵守平台规则你得到的不仅仅是尊重, ${name}愿与各位携手并进共同成长！！

所有${name}会员放心投注！${name}为您保驾护航.`
}

export default defineComponent({
  name: 'ForumRulesPage',
  setup() {
    const goBack = useSmartBack()
    const siteConfigStore = useSiteConfigStore()
    const ruleText = computed(() => buildRuleText(siteConfigStore.siteName))
    return () => (
      <div class="forum-body">
        <VanNavBar
          fixed
          placeholder
          border={false}
          title="六合论坛"
          onClickLeft={() => goBack()}
        >
          {{
            left: () => <VanIcon name="arrow-left" color="#fff" size="16" />,
          }}
        </VanNavBar>

        <div class="forum-body-bd">
          <div class="rule-text">{ruleText.value}</div>
        </div>
      </div>
    )
  },
})
